import { render, staticRenderFns } from "./VacancyTeaser.vue?vue&type=template&id=1cedb85d"
import script from "./VacancyTeaser.vue?vue&type=script&lang=js"
export * from "./VacancyTeaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports